import { takeEvery, all, put, select } from 'redux-saga/effects'
import { push, replace } from 'connected-react-router'
import { reset, startSubmit, stopSubmit } from 'redux-form/immutable'

import { ACTIVITIES_LIST_FORM_NAME as FORM_NAME } from 'app/constants/activities'
import { triggerPostActivitiesList, postActivitiesListBulk, fetchCategoriesTagsForProTrackLevel } from '../actions'
import { showSuccess } from 'store/entities/toastr/utils'
import { getActivitiesInvalid, getActivitiesListForRequest } from 'store/entities/protracks/activities/selectors'
import { reset as resetUnsavedChanges } from 'store/entities/protracks/unsavedChanges/actions'
import { getBlockedPathName } from 'store/entities/protracks/unsavedChanges/selectors'
import i18next from 'i18next'

/**
 * TODO: this file should be removed, because we can use this docs:
 * @see: https://github.com/prohabits/prohabits-ui/wiki/API-Requests
 */
export function* handlePostRequest({
  payload: {
    data: { protrackId, levelId },
    shouldLeavePage,
  },
}) {
  const areActivitiesInvalid = yield select(getActivitiesInvalid)
  if (!areActivitiesInvalid) {
    const activities = yield select(getActivitiesListForRequest)
    yield put(startSubmit(FORM_NAME))
    yield put(postActivitiesListBulk({ values: activities, protrackId, levelId, shouldLeavePage }))
  }
}

export function* handlePostSuccess({ meta: { shouldLeavePage, proTrackId, levelId } }) {
  const blockedPathName = yield select(getBlockedPathName)
  yield put(resetUnsavedChanges())
  yield put(reset(FORM_NAME))
  yield put(stopSubmit(FORM_NAME))
  if (shouldLeavePage && blockedPathName) {
    yield put(push(blockedPathName, { forceLeave: true }))
  }
  yield put(fetchCategoriesTagsForProTrackLevel({ proTrackId, levelId }))
  yield put(replace(location.pathname, { ...location.state, isFromGenerator: false }))
  showSuccess({ content: i18next.t('You successfully updated activities for Level', { level: levelId }) })
}

export function* handlePostFail(error) {
  yield put(stopSubmit(FORM_NAME))
  console.error('error', error)
}

export default function* putActivitySaga() {
  yield all([
    takeEvery(triggerPostActivitiesList, handlePostRequest),
    takeEvery(postActivitiesListBulk.success.toString(), handlePostSuccess),
    takeEvery(postActivitiesListBulk.fail.toString(), handlePostFail),
  ])
}
